import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroupMui from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PropTypes from 'prop-types';

const RadioGroup = ({ options = [], groupTitle = '', defaultRadioValue }) => {
  const handleChange = (_e) => {
    // use 'e.target.value' to access the value
  };

  return (
    <FormControl>
      <FormLabel>{groupTitle}</FormLabel>
      <RadioGroupMui defaultValue={defaultRadioValue} onChange={handleChange}>
        {options.map((opt) => (
          <FormControlLabel
            key={opt?.value}
            value={opt.value}
            control={
              <Radio
                sx={{
                  color: 'black',
                  '&.Mui-checked': {
                    color: 'black',
                  },
                }}
              />
            }
            label={opt.label}
          />
        ))}
      </RadioGroupMui>
    </FormControl>
  );
};

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  groupTitle: PropTypes.string,
  defaultRadioValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RadioGroup;
